// extracted by mini-css-extract-plugin
export default {"titleWrapper":"styles_titleWrapper__IaMuR"};